module.exports = __webpack_public_path__ + "img/appointment@2x.f3af273.jpg";